import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import BottomTabBar from './components/BottomTabBar';
import SearchBar from './components/SearchBar';
import Home from './shell/Home';
import Audiobooks from './shell/Audiobooks';
import Music from './shell/Music';
import Movies from './shell/Movies';
import Videos from './shell/Videos';
import Photos from './shell/Photos';
import Claim from './shell/Claim';
import Search from './shell/Search';
import ItemDetail from './shell/ItemDetail';
import './FamilyVault.css';

export default function FamilyVault() {
  return (
    <BrowserRouter basename="/familyvault">
      <div className="FamilyVault">
        <Sidebar />
        <div className="FamilyVault-main">
          <SearchBar />
          <div className="FamilyVault-scroll">
            <Routes>
              <Route index element={<Home />} />
              <Route path="audiobooks" element={<Audiobooks />} />
              <Route path="music" element={<Music />} />
              <Route path="movies" element={<Movies />} />
              <Route path="videos" element={<Videos />} />
              <Route path="photos" element={<Photos />} />
              <Route path="claim" element={<Claim />} />
              <Route path="search" element={<Search />} />
              <Route path=":mediaType/:id" element={<ItemDetail />} />
            </Routes>
          </div>
        </div>
        <BottomTabBar />
      </div>
    </BrowserRouter>
  );
}
